module.exports = __webpack_public_path__ + "static/media/veranda-login-banner4.e930a1ec.jpg";